'use client'

import ReactMarkdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

const INLINE: Components = { p: 'span' }

export function Markdown({
  markdown,
  inline = false,
}: {
  markdown: string
  /** Paragraphs as spans, for markdown inside a line or a `<p>`. */
  inline?: boolean
}) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={inline ? INLINE : undefined}
    >
      {markdown}
    </ReactMarkdown>
  )
}
